module.exports = __webpack_public_path__ + "img/flag-UY.70f14bcd.png";